import {pageValueIsSet} from "./Page";

export const PROMO_PRIMARY_HERO = 'promo_primary_hero';
export const PROMO_SECONDARY_HERO = 'promo_secondary_hero';
export const PROMO_DESCRIPTION = 'promo_description';
export const PROMO_CTA = 'promo_cta';

export const promoSectionIsEnabled = (page) => {
    return pageValueIsSet(page, PROMO_PRIMARY_HERO) || pageValueIsSet(page, PROMO_SECONDARY_HERO) || pageValueIsSet(page, PROMO_DESCRIPTION);
}

export default {
    promoSectionIsEnabled
}
